if($('.id--16').length){   
    var colorboxContent = '<div class="customDeliveryContent">'
        colorboxContent += '<h5>'+nadpisDopravy+'</h5>'
        colorboxContent += '<p>'+popisDopravy+'</p>'
        colorboxContent += '<form id="validateZip"><fieldset>'
        colorboxContent += '<div class="rowLine"><label for="zip">PSČ</label>'
        colorboxContent += '<input type="text" id="zip" placeholder="např. 701 00" title="Vložte vaše PSČ"></div>'
        colorboxContent += '<div class="rowLine"><input type="submit" value="Ověřit" class="btn btn-secondary"></div>'
        colorboxContent += '</fieldset></form>'
    colorboxContent += '</div>'
    if(zapnutiDoruceni == 1){
        $('#order-shipping-methods').after(colorboxContent)
    }
    else{
        $('body').addClass('noActiveValidate')
    }
    
        $('form#validateZip').on('submit', function(e){
            e.preventDefault();
            $('.deliveryRow').remove()
            var userZip = $('#zip').val().replace(/\s/g, '');
            if (userZip.length === 5 && /^\d+$/.test(userZip)) {
                var csvData = JSON.parse(sessionStorage.getItem('csvDataCombined'));
                if (csvData) {
                    var found = csvData.find(function(row) {
                        return row.PSC === userZip; // Porovnání PSČ
                    });
                    if (found) {
                        sessionStorage.setItem('zipValue', userZip);
                        console.log(found)
                        $('body').addClass('haveShipping')
                        $('.notMinimalOrder').remove()
                        $('#order-shipping-methods').show()
                        $('#order-shipping-methods>div').removeClass('active')
                        $('#order-shipping-methods>div:not("#shipping-'+found['ID-DOPRAVY']+'")').hide()
                        $('#order-shipping-methods>div#shipping-4').show();
                   
                        //$('#order-shipping-methods>div:not("#shipping-'+found['ID-DOPRAVY']+'")').hide()
                        if($('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).length){
                            
                            if (found['POVOLIT-ATYPICKOU'] === '1') {
                                console.log(found['ID-DOPRAVY'])
                                // Speciální logika pro zahrnutí #shipping-67
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).addClass('activeShipping')
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).show()
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                shoptet.checkoutShared.callShippingBillingRelations()
                                $(this).after('<div class="deliveryRow green">'+validniHlaska+'</div>')
                               
                            }
                            else{
                                console.log(found['ID-DOPRAVY'])
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).addClass('active').show()
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']).addClass('activeShipping')
                                $('#order-shipping-methods>div#shipping-'+found['ID-DOPRAVY']+' input').trigger('click')
                                shoptet.checkoutShared.replacingChosenShippingAndBilling();
                                shoptet.checkoutShared.callShippingBillingRelations()
                                $(this).after('<div class="deliveryRow green">'+validniHlaska+'</div>')
                               

                            }
                        }
                        else{
                            $('#order-shipping-methods>div').removeClass('activeShipping')
                            $(this).after('<div class="deliveryRow alert">Do Vaší oblasti doručujeme, ale nemáte splněnou minimální hodnotu objednávky, která je '+minimalniObj+'.</div>')
                            shoptet.checkoutShared.replacingChosenShippingAndBilling();
                            shoptet.checkoutShared.callShippingBillingRelations()
                               
                        }
                       // var billingIds = $('#order-shipping-methods .radio-wrapper.active').find('input:checked').attr('data-relations');
                        //shoptet.checkoutShared.changePaymentRelations(billingIds);
                       
                    } else {
                        sessionStorage.removeItem('zipValue');
                        $('body').removeClass('haveShipping')
                        $('#order-shipping-methods>div:not(.active)').hide()
                        $('.notMinimalOrder').remove()
                        $('#order-shipping-methods>div').removeClass('activeShipping')
                        
                            // PSČ není v našem rozsahu doručování
                            $(this).after('<div class="deliveryRow alert">Litujeme, ale do Vaší oblasti nedoručujeme.</div>')
                    }
                    
                } else {
                    // Nejsou načtená žádná data
                }
            } else {
                // Neplatné PSČ
                $('body').removeClass('haveShipping')
                $('#order-shipping-methods>div:not(.active)').hide()
                $('.notMinimalOrder').remove()
                $('#order-shipping-methods>div').removeClass('activeShipping')
                $(this).after('<div class="deliveryRow alert">Zadejte PSČ ve správném formátu, například 755 01.</div>')

            }
        });
        
   
}

if($('.id--9').length){
    $(document).ready(function(){
       // mhHmotnost()
    });
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
      //  mhHmotnost();
    });
}

if($('.id--17').length){
    var storedZipValue = sessionStorage.getItem('zipValue');
    if(storedZipValue){
        $('#billZip').addClass('disebleInput').val(storedZipValue)
    }
    var totalWeight = 0;
   /* $('.cart-items .cart-item').each(function() {
        var sku = $(this).data('micro-sku').toString(); 
        var price = parseFloat($(this).find('.cart-item-price').text().replace(/ /g, ''))
        var amount = parseFloat($(this).find('.cart-item-amount').text().replace(/ /g, ''))
        if (productInfoByCode.hasOwnProperty(sku)) {
            var weightPerItem = productInfoByCode[sku].weight;
            var weightForThisItem = weightPerItem * amount;
            totalWeight += weightForThisItem;
            $(this).find('.cart-item-name').append('<span class="blockBox" style="display:block;color:#666;">(1 paleta má '+ weightPerItem + ' kg)');

        }
    });*/
    var price = parseFloat($('.price-wrapper .price.price-primary span').text().replace(/ /g, '').replace('€', ''));
   // $('.price-wrapper').append('<span class="price-label price-secondary">Cena za kilogram</span><strong class="price price-secondary"><span>'+Number(price/totalWeight).ShoptetFormatAsCurrency()+' /kg</span></strong>');
    $('input#add-note').trigger('click').attr("checked", true);
    $('#note').addClass('visible')
    $('label[for="add-note"]').text(nadpisPoznamky);
    $('#remark').attr('placeholder', popisPoznamky).attr("required", true);
    
}

function mhHmotnost(){
    $('.cart-table tr.removeable').each(function() {
        var sku = $(this).data('micro-sku').toString(); 
        if (productInfoByCode.hasOwnProperty(sku)) {
            $(this).find('.unit-value').append(' <br>(' + productInfoByCode[sku].weight + ' kg)');
        }
    });
}

if($('.id--15').length){
    $(document).ready(function(){
        var productInfoByName = {};
        for (var sku in productInfoByCode) {
            if (productInfoByCode.hasOwnProperty(sku)) {
                var productInfo = productInfoByCode[sku];
                productInfoByName[productInfo.name] = { weight: productInfo.weight, sku: sku };
            }
        }

        $('.co-order table tr').each(function() {
            var name = $(this).find('.p-name span[data-testid="recapItemName"]').text().trim(); 
            if (productInfoByName.hasOwnProperty(name)) {
                var productInfo = productInfoByName[name];
                var weight = productInfo.weight;
                var name = productInfo.name;
                $(this).find('.p-quantity').append('<span class="blockBox" style="display:block;color:#666;">(1 paleta má '+ weight + ' kg)');
            }
        });
    })
    
}